import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { questionnaireService } from '../services/questionnaireService';

export const getTemplate = createAsyncThunk(
  'questionnaire/getTemplate',
  async (_, { rejectWithValue }) => {
    try {
      const response = await questionnaireService.getTemplate();
      return response?.data || response;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const createQuestionnaire = createAsyncThunk(
  'questionnaire/createQuestionnaire',
  async ({ providerId, questionnaireType }, { rejectWithValue }) => {
    try {
      const response = await questionnaireService.createQuestionnaire(providerId, questionnaireType);
      return response?.data || response;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const questionnaireSlice = createSlice({
  name: 'questionnaire',
  initialState: {
    template: null,
    questionnaire: null,
    loading: false,
    error: null,
  },
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getTemplate.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getTemplate.fulfilled, (state, action) => {
        state.loading = false;
        state.template = action.payload;
      })
      .addCase(getTemplate.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(createQuestionnaire.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createQuestionnaire.fulfilled, (state, action) => {
        state.loading = false;
        state.questionnaire = action.payload;
      })
      .addCase(createQuestionnaire.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearError } = questionnaireSlice.actions;

export default questionnaireSlice.reducer;
